import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useRef, useEffect, Children } from 'react';
import { clsx } from 'clsx';
import { LegacyIconButton } from '../../navigation/LegacyIconButton/IconButton.es.js';
import { useUnscrollableBody } from './useUnscrollableBody.es.js';
import { useFocusTrap } from './useFocusTrap.es.js';

const root = "_root_17zwg_17";
const rootIn = "_root-in_17zwg_27";
const fadeIn = "_fade-in_17zwg_1";
const rootOut = "_root-out_17zwg_37";
const fadeOut = "_fade-out_17zwg_1";
const overlay = "_overlay_17zwg_47";
const modal = "_modal_17zwg_56";
const styles = {
	root: root,
	rootIn: rootIn,
	fadeIn: fadeIn,
	rootOut: rootOut,
	fadeOut: fadeOut,
	overlay: overlay,
	modal: modal
};

const Modal = ({ "aria-label": ariaLabel = void 0, canClose = true, canScrollBody, children, onClosed }) => {
  const [isOpen, setIsOpen] = useState(true);
  const modalRef = useRef(null);
  useUnscrollableBody({ shouldAllowScroll: canScrollBody === true });
  const onClose = () => {
    if (canClose) {
      setIsOpen(false);
    }
  };
  const onAnimationEnd = () => {
    if (isOpen === false) {
      onClosed();
    }
  };
  useEffect(() => {
    const onEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keyup", onEscape, { capture: true });
    return () => {
      window.removeEventListener("keyup", onEscape, { capture: true });
    };
  });
  useFocusTrap(modalRef);
  const overlay = (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsx("div", { className: styles.overlay, "data-testid": "ModalOverlay", onClick: onClose })
  );
  const closeButton = !!canClose && jsx(LegacyIconButton, { "aria-label": "Close modal", color: "icon-ghost", icon: "formX", onClick: onClose, size: "medium" });
  const onlyChild = children && Children.only(children);
  const modalChildren = Object.assign(Object.assign({}, onlyChild), { props: Object.assign(Object.assign({}, children.props || {}), { closeButton }) });
  const modal = jsx("div", { "aria-label": ariaLabel, "aria-live": "polite", "aria-modal": "true", className: styles.modal, ref: modalRef, role: "dialog", "data-zds": true, children: modalChildren });
  return jsxs("div", { className: clsx(styles.root, isOpen ? styles.rootIn : styles.rootOut), "data-testid": "Modal", onAnimationEnd, "data-zds": true, children: [overlay, modal] });
};

export { Modal };
//# sourceMappingURL=Modal.es.js.map
